import { useState } from 'react';
import { Button, Icon, ListSubheader, MenuItem, Select, Stack, Text } from 'shell/components';

const options1 = [
    {
        key: 'canada',
        value: (
            <Stack alignItems={'center'} direction={'row'} spacing={2}>
                <Icon kind={'canada'} />
                Canada
            </Stack>
        ),
    },
    {
        key: 'usa',
        value: (
            <Stack alignItems={'center'} direction={'row'} spacing={2}>
                <Icon kind={'usa'} />
                USA
            </Stack>
        ),
    },
];

const SelectDemo = () => {
    const [value1, setValue1] = useState(options1[0].key);
    const [value2, setValue2] = useState('');

    return (
        <>
            <Text variant={'sh1'}>Select</Text>
            <Select defaultValue={''}>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
                <MenuItem value={'option-4'}>Option 4</MenuItem>
                <MenuItem value={'option-5'}>Option 5</MenuItem>
                <MenuItem value={'option-6'}>Option 6</MenuItem>
                <MenuItem value={'option-7'}>Option 7</MenuItem>
                <MenuItem value={'option-8'}>Option 8</MenuItem>
            </Select>
            <Select defaultValue={''} error>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
                <MenuItem value={'option-4'}>Option 4</MenuItem>
                <MenuItem value={'option-5'}>Option 5</MenuItem>
                <MenuItem value={'option-6'}>Option 6</MenuItem>
                <MenuItem value={'option-7'}>Option 7</MenuItem>
                <MenuItem value={'option-8'}>Option 8</MenuItem>
            </Select>
            <Select defaultValue={''} disabled>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
                <MenuItem value={'option-4'}>Option 4</MenuItem>
                <MenuItem value={'option-5'}>Option 5</MenuItem>
                <MenuItem value={'option-6'}>Option 6</MenuItem>
                <MenuItem value={'option-7'}>Option 7</MenuItem>
                <MenuItem value={'option-8'}>Option 8</MenuItem>
            </Select>

            <Select defaultValue={''} label={'Form label'} labelId={'select-1'}>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
                <MenuItem value={'option-4'}>Option 4</MenuItem>
                <MenuItem value={'option-5'}>Option 5</MenuItem>
                <MenuItem value={'option-6'}>Option 6</MenuItem>
                <MenuItem value={'option-7'}>Option 7</MenuItem>
                <MenuItem value={'option-8'}>Option 8</MenuItem>
            </Select>
            <Select defaultValue={''} error label={'Form label'} labelId={'select-2'}>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
                <MenuItem value={'option-4'}>Option 4</MenuItem>
                <MenuItem value={'option-5'}>Option 5</MenuItem>
                <MenuItem value={'option-6'}>Option 6</MenuItem>
                <MenuItem value={'option-7'}>Option 7</MenuItem>
                <MenuItem value={'option-8'}>Option 8</MenuItem>
            </Select>
            <Select defaultValue={''} disabled label={'Form label'} labelId={'select-3'}>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
                <MenuItem value={'option-4'}>Option 4</MenuItem>
                <MenuItem value={'option-5'}>Option 5</MenuItem>
                <MenuItem value={'option-6'}>Option 6</MenuItem>
                <MenuItem value={'option-7'}>Option 7</MenuItem>
                <MenuItem value={'option-8'}>Option 8</MenuItem>
            </Select>

            <Select defaultValue={''} label={'Form label'} labelId={'select-4'} required>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
                <MenuItem value={'option-4'}>Option 4</MenuItem>
                <MenuItem value={'option-5'}>Option 5</MenuItem>
                <MenuItem value={'option-6'}>Option 6</MenuItem>
                <MenuItem value={'option-7'}>Option 7</MenuItem>
                <MenuItem value={'option-8'}>Option 8</MenuItem>
            </Select>
            <Select defaultValue={''} error label={'Form label'} labelId={'select-5'} required>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
                <MenuItem value={'option-4'}>Option 4</MenuItem>
                <MenuItem value={'option-5'}>Option 5</MenuItem>
                <MenuItem value={'option-6'}>Option 6</MenuItem>
                <MenuItem value={'option-7'}>Option 7</MenuItem>
                <MenuItem value={'option-8'}>Option 8</MenuItem>
            </Select>
            <Select defaultValue={''} disabled label={'Form label'} labelId={'select-6'} required>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
                <MenuItem value={'option-4'}>Option 4</MenuItem>
                <MenuItem value={'option-5'}>Option 5</MenuItem>
                <MenuItem value={'option-6'}>Option 6</MenuItem>
                <MenuItem value={'option-7'}>Option 7</MenuItem>
                <MenuItem value={'option-8'}>Option 8</MenuItem>
            </Select>

            <Select
                label={'Region'}
                labelId={'region-select'}
                renderValue={(selected) => {
                    return options1.find(({ key }) => key === selected).value;
                }}
                value={value1}
                onChange={(e) => setValue1(e.target.value)}
            >
                {options1.map(({ key, value }) => (
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                ))}
            </Select>

            <Select
                label={'Subheader'}
                labelId={'select-7'}
                value={value2}
                onChange={(e) => {
                    if (!e.target.value) return;
                    setValue2(e.target.value);
                }}
            >
                <Button sx={{ p: 1 }} startIcon={<Icon kind={'add'} />} variant={'borderless'}>
                    Add a new option
                </Button>
                <ListSubheader>
                    <Text color={'light'} variant={'p3'}>
                        EXISTING OPTIONS
                    </Text>
                </ListSubheader>
                <MenuItem value={'option-1'}>Option 1</MenuItem>
                <MenuItem value={'option-2'}>Option 2</MenuItem>
                <MenuItem value={'option-3'}>Option 3</MenuItem>
            </Select>
        </>
    );
};

export default SelectDemo;
